import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "select",
    "customField",
    "customInput",
    "preview",
    "nameField",
  ];

  static values = { config: Object };

  connect() {
    this.updateAllCustomFields();
    this.updatePreview();
  }

  segmentChanged() {
    this.updateAllCustomFields();
    this.updatePreview();
  }

  updateAllCustomFields() {
    const otherId = this.configValue.otherOptionId;

    this.selectTargets.forEach((select) => {
      const key = select.dataset.segmentKey;
      const customField = this.customFieldTargets.find(
        (field) => field.dataset.segmentKey === key
      );
      if (!customField) return;

      const isOther = select.value === otherId;
      customField.classList.toggle("d-none", !isOther);
    });
  }

  updatePreview() {
    const parts = [];
    const otherId = this.configValue.otherOptionId;
    const optionalKeys = this.configValue.optionalSegmentKeys || [];

    this.configValue.segments.forEach((segment) => {
      const select = this.selectTargets.find(
        (target) => target.dataset.segmentKey === segment.key
      );
      if (!select) return;

      const selected = select.value;
      if (!selected) {
        if (optionalKeys.includes(segment.key)) return;
        return;
      }

      let code = null;
      if (selected === otherId) {
        const customInput = this.customInputTargets.find(
          (input) => input.dataset.segmentKey === segment.key
        );
        code = customInput?.value.trim();
      } else {
        const option = segment.options.find(
          (entry) => entry.id === selected
        );
        code = option?.code;
      }

      if (code) parts.push(code);
    });

    const composed = parts.length ? parts.join("-") : "—";
    this.previewTarget.textContent = composed;

    if (this.hasNameFieldTarget) {
      this.nameFieldTarget.value = composed === "—" ? "" : composed;
    }
  }
}
